import React from "react";
import PropTypes from "prop-types";

import SplitLayout from "components/Library/Layout/components/SplitLayout";
import BylinePhoto from "cards/components/BylinePhoto";
import Byline from "cards/components/Byline";
import PubDate from "cards/components/PubDate";
import ConnectedSaveButton from "cards/containers/ConnectedSaveButton";

export default function BylineWrapper({ story, showSaveTag, className }) {
  return(
    <SplitLayout
      left={
        <React.Fragment>
          <BylinePhoto photoSrc={story.byline_photo} />
          <Byline authors={story.authors}/>
          <PubDate story={story} />
        </React.Fragment>
      }
      right={
        showSaveTag ?
          <ConnectedSaveButton
            id={story.id}
          /> :
          undefined
      }
      className={className}
    />
  );
}

BylineWrapper.propTypes = {
  story: PropTypes.object.isRequired,
  showSaveTag: PropTypes.bool,
  className: PropTypes.string,
};
